import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import './report.css'

const MetricPanel = ({ user, currentMetric, currentScan, title }) => {
  const units = user.get('user').get('units')
  const facility = user.get('user').get('facility')

  let weight = 'lbs'
  let length = 'inches'

  if (units !== 'US') {
    weight = 'kg'
    length = 'cm'
  }

  const rawHwVersion =
    currentScan && typeof currentScan.get === 'function'
      ? currentScan.get('hwVersion')
      : currentScan && currentScan.hwVersion

  const hwVersion =
    typeof rawHwVersion === 'number'
      ? rawHwVersion
      : rawHwVersion
      ? parseInt(rawHwVersion, 10)
      : null

  const vatMassValue = currentMetric ? currentMetric.get('vatMass') : null
  const parsedVatMass =
    typeof vatMassValue === 'number'
      ? vatMassValue
      : vatMassValue !== null && vatMassValue !== undefined
      ? parseFloat(vatMassValue)
      : null

  // VAT Mass is only valid for HW v7 scans when BFP access is enabled
  const hasVatMass =
    facility &&
    facility.get('bfpAccess') === 1 &&
    hwVersion === 7 &&
    parsedVatMass !== null &&
    !Number.isNaN(parsedVatMass) &&
    parsedVatMass > 0

  const isSnapScan = hwVersion === 7

  // Get metabolicAgeYears value for snap scans
  const metabolicAgeValue = currentMetric
    ? currentMetric.get('metabolicAgeYears')
    : null
  const hasMetabolicAge =
    isSnapScan &&
    metabolicAgeValue !== null &&
    metabolicAgeValue !== undefined &&
    metabolicAgeValue > 0

  const metricGroup = {
    'Body Shape': isSnapScan
      ? ['bodyShapeRating']
      : ['bodyShapeRating', 'trunkLegVolRatio'],
    'Body Composition': ['weight', 'bfp', 'fatMass', 'leanMass'],
    Additional: isSnapScan
      ? ['wc', 'whr', ...(hasMetabolicAge ? ['metabolicAgeYears'] : [])]
      : ['wc', 'whr'],
  }

  if (facility && facility.get('bfpAccess') !== 1) {
    metricGroup['Body Composition'] = ['weight', 'height']
  } else if (hasVatMass) {
    metricGroup['Body Composition'] = [
      ...metricGroup['Body Composition'],
      'vatMass',
    ]
  }

  const metricNames = {
    bodyShapeRating: { value: 'Body Shape Rating', units: '' },
    // absi: { value: 'ABSI', units: '' },
    // sbsi: { value: 'SBSI', units: '' },
    trunkLegVolRatio: { value: 'Trunk to Leg Volume Ratio', units: '' },
    bfp: { value: 'Body Fat Percentage', units: '%' },
    fatMass: { value: 'Fat Mass', units: weight },
    leanMass: { value: 'Lean Mass', units: weight },
    weight: { value: 'Weight', units: weight },
    height: { value: 'Height', units: length },
    wc: { value: 'Waist Circumference', units: length },
    whr: { value: 'Waist to Hip Ratio', units: '' },
    vatMass: { value: 'VAT Mass', units: weight },
    metabolicAgeYears: { value: 'Metabolic Age', units: 'years' },
  }

  const getMetricDisplayValue = (metricKey) => {
    const value = currentMetric ? currentMetric.get(metricKey) : null

    if (value === null || value === undefined || value === '') {
      return 'N/A'
    }

    if (metricKey === 'vatMass') {
      const numericValue = typeof value === 'number' ? value : parseFloat(value)

      if (Number.isNaN(numericValue)) {
        return 'N/A'
      }

      return numericValue.toFixed(1)
    }

    return value
  }

  return (
    <div
      className="card card-default mb-3"
      style={{ width: '100%', borderRadius: 0 }}
    >
      <div className="text-center">
        <div className="p-3" style={{ fontSize: '20px' }}>
          {title}
        </div>
      </div>
      <div className="card-body py-0">
        <table className="table" responsive>
          <thead>
            <tr>
              <th>Name</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            {metricGroup[title].map((metric) => (
              <tr key={_.uniqueId()}>
                <td>{metricNames[metric].value}</td>
                <td style={{ width: '30%' }}>
                  <span isolate>{getMetricDisplayValue(metric)}</span>
                  <span isolate>{` ${metricNames[metric].units}`}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

MetricPanel.propTypes = {
  currentMetric: PropTypes.object,
  user: PropTypes.object,
  currentScan: PropTypes.object,
  title: PropTypes.string,
}

export default MetricPanel
